export default __webpack_public_path__ + "static/meshery-star-notifications-f740d6d6495b12e02c095df8bea55595.webp";